import {
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import { ShoppingCartService } from '../shopping-cart/shopping-cart.service';
import { RequestModel } from '../shopping-cart/request-model.model';
import { DuplicateModalComponent } from './duplicate-modal/duplicate-modal.component';
import { IndProvModalComponent } from '../main/ind-prov-modal/ind-prov-modal.component';
import { DeleteModalComponent } from './delete-modal/delete-modal.component';
import { DentPracModalComponent } from '../main/dent-prac-modal/dent-prac-modal.component';
import { DomSanitizer } from '@angular/platform-browser';
import { EventService } from '../main/event-service/event.service';

@Component({
  selector: 'app-display-request-table',
  templateUrl: './display-request-table.component.html',
  styleUrls: ['./display-request-table.component.scss']
})
export class DisplayRequestTableComponent {
  @Input() public requests: RequestModel[] = [];
  @ViewChild(DuplicateModalComponent, { static: true }) childModal: DuplicateModalComponent;
  @ViewChild(IndProvModalComponent) editModal: IndProvModalComponent;
  @ViewChild(DentPracModalComponent) editGroupModal: DentPracModalComponent;
  @ViewChild(DeleteModalComponent, { static: true }) deleteModal: DeleteModalComponent;

  private _document;
  private _IE = window.navigator.msSaveOrOpenBlob;

  constructor(
    private cartService: ShoppingCartService,
    private sanitizer: DomSanitizer,
    private eventService: EventService
  ) { }

  public duplicateRequest(index: number, providerType: string) {
    this.childModal.openModalWithClass(this.cartService.duplicate(index));
  }

  public editRequest(index: number, requestType: string, providerType: string): void {
    this.eventService.request = index;

    providerType === 'PROVIDER'
    ? this.editModal.openModalWithClass(requestType)
    : this.editGroupModal.openModalWithClass(requestType);
  }

  public deleteRequest(index: number): void {
    this.eventService.request = null;
    this.deleteModal.openModalWithClass(index);
  }

  public getDocument(file: File) {
    const data = file;
    const blob = new Blob([data], { type: 'application/octet-stream' });

    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, data.name);
    }
    else {
      this.document = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
    }
  }

  public deleteDocument(index: number): void {
    this.cartService.removeDocument(index);
  }

  public get document() {
    return this._document;
  }

  public set document(value) {
    this._document = value;
  }

  public get IE() {
    return this._IE;
  }

  public set IE(value) {
    this._IE = value;
  }
}
